import { TYPES } from "../../common/constants";
import * as client from "../../services/client";
export const addFilterServicesProviderAndPropertyDeveloperList = (payload) => ({
  type: TYPES.ADD_FILTER_SERVICE_PROVIDER_AND_PROPERTY_DEVELOPER,
  payload,
});
export const fetchServicesProviderAndPropertyDeveloperList = (LoginUserId,Role)=>(dispatch) => {
  return  client.fetchServicesProviderAndPropertyDeveloperList(LoginUserId,Role).then((response) => {
    if (response.ok || response.status === 200) {
      response
        .json()
        .then((responsejson) =>
       {
        let servicesProviderAndPropertyDeveloperList=responsejson
      dispatch(addFilterServicesProviderAndPropertyDeveloperList(responsejson))
        return (servicesProviderAndPropertyDeveloperList)
       }
        );
    }
  });
};
export const clearFilterServicesProviderAndPropertyDeveloperList = () => ({
  type: TYPES.CLEAR_FILTER_SERVICE_PROVIDER_AND_PROPERTY_DEVELOPER,
});
